import ScalarTeleport_default from "../ScalarTeleport/ScalarTeleport.vue.js";
import { useResizeWithTarget } from "./useResizeWithTarget.js";
import { Fragment, computed, createBlock, createCommentVNode, createElementBlock, createElementVNode, defineComponent, nextTick, normalizeClass, normalizeStyle, openBlock, ref, renderSlot, unref, withCtx } from "vue";
import { getSideAxis } from "@floating-ui/utils";
import { autoUpdate, flip, offset, shift, size, useFloating } from "@floating-ui/vue";
var ScalarFloating_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	inheritAttrs: false,
	__name: "ScalarFloating",
	props: {
		placement: {},
		offset: {
			type: [
				Number,
				Object,
				Function
			],
			default: 5
		},
		resize: {
			type: Boolean,
			default: false
		},
		target: {},
		middleware: { default: () => [] },
		teleport: { type: [Boolean, String] }
	},
	setup(__props, { expose: __expose }) {
		const floatingRef = ref(null);
		const wrapperRef = ref(null);
		const targetRef = computed(() => {
			if (typeof window !== "undefined" && wrapperRef.value) {
				if (typeof __props.target === "string") {
					const t = document.getElementById(__props.target);
					if (t) return t;
					console.warn(`ScalarFloating: Target with id="${__props.target}" not found`);
				} else if (__props.target instanceof HTMLElement) return __props.target;
				const firstChild = wrapperRef.value.children?.[0];
				if (firstChild instanceof HTMLElement) return firstChild;
				return wrapperRef.value;
			}
		});
		const targetSize = useResizeWithTarget(targetRef, { enabled: computed(() => __props.resize) });
		const targetWidth = computed(() => getSideAxis(__props.placement ?? "bottom") === "y" ? targetSize.width.value : void 0);
		const targetHeight = computed(() => getSideAxis(__props.placement ?? "bottom") === "x" ? targetSize.height.value : void 0);
		/**
		* Starts Floating UI's `autoUpdate` one tick after both elements exist.
		*
		* `useFloating` attaches `autoUpdate` from a synchronous watch the moment the
		* template refs resolve, and `autoUpdate` positions the element right away.
		* Template refs resolve in the post-render phase of a flush, so that first
		* `computePosition` reads layout while the same flush is still mounting other
		* components: every floating element mounted together (for example the closed
		* listboxes of a schema with many compositions) forces its own style recalc and
		* layout on a tree that was dirtied again in between. Waiting for `nextTick`
		* runs every first positioning back-to-back once the flush has settled, so the
		* browser recalculates the tree once for all of them. The tick resolves before
		* the next paint, so an element that mounts open is positioned in the same task.
		*/
		const deferredAutoUpdate = (reference, floating, update, options) => {
			let cleanup;
			let disposed = false;
			nextTick(() => {
				if (!disposed) cleanup = autoUpdate(reference, floating, update, options);
			});
			return () => {
				disposed = true;
				cleanup?.();
			};
		};
		const { floatingStyles, middlewareData } = useFloating(targetRef, floatingRef, {
			placement: computed(() => __props.placement ?? "bottom"),
			whileElementsMounted: deferredAutoUpdate,
			middleware: computed(() => [
				offset(__props.offset),
				flip({ padding: 48 }),
				shift({ padding: 8 }),
				size({ apply({ availableWidth, availableHeight, elements }) {
					Object.assign(elements.floating.style, {
						maxWidth: `${Math.max(0, availableWidth) - 16}px`,
						maxHeight: `${Math.max(0, availableHeight) - 16}px`
					});
				} }),
				...__props.middleware
			])
		});
		__expose({ 
		/** The resolved target element */
targetRef });
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [createElementVNode("div", {
				ref_key: "wrapperRef",
				ref: wrapperRef,
				class: normalizeClass({ contents: !!_ctx.$slots.default })
			}, [renderSlot(_ctx.$slots, "default")], 2), _ctx.$slots.floating ? (openBlock(), createBlock(unref(ScalarTeleport_default), {
				key: 0,
				disabled: !__props.teleport,
				to: typeof __props.teleport === "string" ? __props.teleport : void 0
			}, {
				default: withCtx(() => [createElementVNode("div", {
					ref_key: "floatingRef",
					ref: floatingRef,
					class: "z-context relative",
					style: normalizeStyle(unref(floatingStyles))
				}, [renderSlot(_ctx.$slots, "floating", {
					data: unref(middlewareData),
					height: targetHeight.value,
					width: targetWidth.value
				})], 4)]),
				_: 3
			}, 8, ["disabled", "to"])) : createCommentVNode("", true)], 64);
		};
	}
});
//#endregion
export { ScalarFloating_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarFloating.vue_vue_type_script_setup_true_lang.js.map